import React, { useEffect, useState } from 'react'
import PatientOrdersCRUD from '../../services/general/patientOrders.api'
import AddAddendumOrder from '../../views/dashboard/AddAddendumOrder'
import { CButton, CFormTextarea, CNav, CNavItem, CNavLink, CTabContent, CTabPane } from '@coreui/react'
import ProviderOrder from '../../views/dashboard/ProviderOrder'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import SaveExtra from '../../services/general/saveExtraData.api'

const AddAddendumData = ({ patientID, noteID, setShowAddendum }) => {
  const [allOrders, setAllOrders] = useState([])
  const [activeKey, setActiveKey] = useState(1)
  const [pastOrders, setPastOrders] = useState([])
  const [poacText, setPoacText] = useState('')
  const fetchOrdersAgain = async () => {
    try {
      let data = await PatientOrdersCRUD('Get', '', patientID)

      data = JSON.parse(data?.d).Data || []

      const parsedOrders = data
        ?.map((order) => ({
          id: order.id,
          date: order.date,
          medication: JSON.parse(order.medication),
        }))
        .filter((item) => item.medication?.noteID === parseInt(noteID))

      setPastOrders(parsedOrders)
    } catch (error) {
      console.error('Failed to fetch or parse orders:', error)
    }
  }

  // internet checker
  const checkInternet = async () => {
    try {
      await fetch('https://www.google.com/favicon.ico', {
        mode: 'no-cors',
        cache: 'no-store',
      })
      return true
    } catch {
      return false
    }
  }

  const handleSubmit = async () => {
    if (!(await checkInternet())) {
      toast.error('No internet connection. Please check your network.', toastConfig)
      return
    }
    const date = new Date()
    const syncDate = `${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}-${date.getFullYear()}`

    let addendumStructure = {
      [patientID]: {
        [noteID]: {
          orders: allOrders,
          poac: [
            {
              poacData: {
                type: 'text',
                content: poacText,
                Pdate: syncDate,
              },
            },
          ],
          syncDate: syncDate,
        },
      },
    }
    console.log('addendum structure', addendumStructure)
    await SaveExtra('Insert', 'Addendum', JSON.stringify(addendumStructure))
    setAllOrders([])
    setPoacText('')
    toast.success('Addendum saved successfully', toastConfig)
  }

  useEffect(() => {
    fetchOrdersAgain()
  }, [])
  return (
    <>
      <div className="d-flex flex-column   justify-content-between h-100">
        <div>
          {/* Tab Navigation */}
          <div className="d-flex justify-content-center gap-2 my-2">
            <button className={`btn ${activeKey === 1 ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => setActiveKey(1)}>
              Order
            </button>
            <button className={`btn ${activeKey === 2 ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => setActiveKey(2)}>
              POAC
            </button>
          </div>

          {/* Tab Content */}
          <div className="mt-1">
            <CTabContent className="  border-top-0 rounded-bottom">
              <CTabPane visible={activeKey === 1}>
                <div className=" " style={{ height: '450px', overflow: 'auto' }}>
                  <ProviderOrder setPastOrders={setPastOrders} fetchOrdersAgain={fetchOrdersAgain} patientID={patientID} noteID={noteID} orders={pastOrders} allOrders={allOrders} setAllOrders={setAllOrders} callType={'addendum'} showHeader={false} />
                </div>
              </CTabPane>
              <CTabPane visible={activeKey === 2}>
                <CFormTextarea id="poacTextarea" label="POAC Notes" style={{ height: '200px', background: '#191919', color: 'white' }} placeholder="Enter POAC here..." value={poacText} onChange={(e) => setPoacText(e.target.value)} />{' '}
              </CTabPane>
            </CTabContent>
          </div>
        </div>
        <div className="d-flex justify-content-end gap-2 ">
          <CButton
            onClick={() => {
              setShowAddendum(false)
            }}
            color="secondary"
            variant="outline"
          >
            Close
          </CButton>
          <CButton
            onClick={() => {
              handleSubmit()
              setShowAddendum(false)
            }}
            // variant="outline"
            color="primary"
          >
            Save Addendum
          </CButton>
        </div>
      </div>
    </>
  )
}

export default AddAddendumData
